import React from 'react';
// @ts-ignore
import styles from './ActionCenterInbox.module.scss';
import ActionCenterConversationList from '../ActionCenterConversationList/ActionCenterConversationList';
import { ConversationListType } from '../../Enums/ConversationListType.enum';

const ActionCenterInbox: React.FC = () => {
	return (
		<div className={styles.wrapper}>
			<ActionCenterConversationList type={ConversationListType.INBOX} />
		</div>
	);
};

export default ActionCenterInbox;
